<template>
  <b-modal
    id="share-survey-modal"
    class="custom-modal"
    title="Share Survey"
    centered
    no-close-on-backdrop
    @hidden="clearSurveyLink"
  >
    <b-input
      :value="surveyLink"
      readonly
      class="bg-white"
      id="survey-link-input"
    />
    <div slot="modal-footer">
      <b-btn variant="primary" @click="copyLink">
        <img
          src="@/assets/images/actions/link.svg"
          alt="Link Icon"
          class="mr-1"
        />
        Copy Link
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import notification from "@/services/notification";

export default {
  name: "ShareSurveyModal",
  computed: {
    ...mapGetters("surveys", ["surveyLink"])
  },
  methods: {
    ...mapMutations("surveys", ["setSurveyLink"]),
    copyLink() {
      document.getElementById("survey-link-input").select();
      document.execCommand("copy");
      notification.success("Link Copied!");
    },
    clearSurveyLink() {
      this.setSurveyLink(null);
    }
  },
};
</script>

<style>
</style>